import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ProductsSummaryComponent } from '../../products-summary.component';
import { AddressComponent } from '../../../../address/address.component';
import { BasicCardComponent } from '../../../../cards/basic-card/basic-card.component';
import { HeadlineComponent } from '../../../../headline/headline.component';
import { ProductIconComponent } from '../../../../product-icon/product-icon.component';
import { ProductsSummaryInvoiceOldComponent } from '../../products-summary-invoice-old.component';
import { TariffCardWaermeComponent } from '../../../../tariff/products/waerme/tariff-card-waerme.component';
import { TariffSelectionContainerComponent } from '../../../../tariff/tariff-selection-container/tariff-selection-container.component';
import { CorrelatedCompanyReferencePipe, FormatPhoneNumberPipe } from '@mwe/ui/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoboxComponent } from '../../../../infobox/infobox.component';
import { ProductSummaryContractInfoComponent } from '../../product-summary-contract-info.component';
import { WizardProductCardComponent } from '../../../../product-card/wizard-product-card/wizard-product-card.component';
import { BenefitsCardComponent } from '../../../benefits-card/benefits-card.component';

@Component({
  selector: 'mwe-products-summary-relocation-new-address',
  templateUrl: './products-summary-relocation-new-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BasicCardComponent,
    CorrelatedCompanyReferencePipe,
    HeadlineComponent,
    ProductIconComponent,
    ProductsSummaryInvoiceOldComponent,
    TariffCardWaermeComponent,
    TariffSelectionContainerComponent,
    TranslatePipe,
    AddressComponent,
    InfoboxComponent,
    ProductSummaryContractInfoComponent,
    WizardProductCardComponent,
    BenefitsCardComponent,
    FormatPhoneNumberPipe,
  ],
})
export class ProductsSummaryRelocationNewAddressComponent extends ProductsSummaryComponent {
  readonly hasMatchingPriceSheets = input<boolean>(false);
  readonly hideInvoiceAlert = input<boolean>(false);

  readonly fernWaermePlaceholderRecord = computed(() => Object.fromEntries(this.registerFernwaermeTextPlaceholder()));

  readonly stromOrGasProductsWithoutTariffs = computed(() => {
    const selectedTariffs = this.selectedTariffs();
    const stromOrGasProducts = this.nonFernwaermeProducts();

    if (selectedTariffs.length === 0) return stromOrGasProducts;

    return stromOrGasProducts.filter(product => selectedTariffs.every(tariff => tariff.tariffKey !== product.tarifKey));
  });
}
